import React from 'react';
import './PurposeSection.css';
import purp from '../purpose.jpeg';

const PurposeSection = () => {
  return (
    <section className="purpose-section">
      <div className="purpose-container">
        <div className="purpose-image">
          <div className="image-placeholder">
            <img 
              src={purp} 
              alt="Team collaboration" 
              className="purpose-main-image"
            />
            <div className="image-overlay">
              <span>Crafting Success, Step by Step</span>
            </div>
          </div>
        </div>
        <div className="purpose-content">
          <h2 className="purpose-title">Our Purpose and Aspiration</h2>
          <div className="purpose-text">
            <p>
              Driven by innovation and cutting-edge technology, our mission is to empower businesses with transformative digital solutions. We envision a future where technology bridges gaps, enhances efficiency, and unlocks new possibilities for growth.
            </p>
            <p>
              At our core, we value integrity, excellence, and collaboration, guiding us as we deliver scalable, secure, and future-ready IT solutions that drive success for our clients.
            </p>
          </div>
          <div className="purpose-separator"></div>
          <div className="purpose-metrics">
            <div className="metric">
              <div className="metric-icon">
                <span>✈</span>
              </div>
              <div className="metric-text">
                <div className="metric-number">Best of the best</div>
                <div className="metric-label">Global Presence</div>
              </div>
            </div>
            <div className="metric">
              <div className="metric-icon">
                <span>%</span>
              </div>
              <div className="metric-text">
                <div className="metric-number">95%</div>
                <div className="metric-label">Job Success</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PurposeSection; 